import { render } from "./InvalidView.vue?vue&type=template&id=6625a6a4"
import script from "./InvalidView.vue?vue&type=script&lang=js"
export * from "./InvalidView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__